import React, { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0a0c0a",
          color: "#e8ede6",
          fontFamily: "system-ui, -apple-system, sans-serif",
          padding: "24px",
          textAlign: "center",
        }}>
          <div style={{
            maxWidth: "480px",
            padding: "32px",
            background: "#141814",
            border: "1px solid rgba(163,230,53,0.2)",
            borderRadius: "16px",
            boxShadow: "0 20px 40px rgba(0,0,0,0.6)",
          }}>
            <div style={{ fontSize: "36px", marginBottom: "16px" }}>⚠️</div>
            <h2 style={{ fontSize: "20px", fontWeight: 600, marginBottom: "8px", color: "#f7fee7" }}>
              Automatrix IA — Sistema em Recuperação
            </h2>
            <p style={{ fontSize: "14px", color: "#8a9a86", marginBottom: "20px", lineHeight: 1.5 }}>
              Ocorreu uma oscilação na renderização. Clique abaixo para reiniciar a interface com cache limpo.
            </p>
            <button
              onClick={this.handleReload}
              style={{
                background: "#a3e635",
                color: "#0a0c0a",
                border: "none",
                fontWeight: 600,
                padding: "12px 24px",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              Recarregar Aplicação
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
